module.exports = __webpack_public_path__ + "img/icone_studio_export-1.4a38c1ed.png";